function createSearchButton($filter) {
    return $('<button />', {
        type: 'button',
        'data-search': true,
        'data-value': $filter.val(),
        class: 'btn btn-outline-primary btn-sm active me-8'
    }).text(`${$filter.data('search')}: ${$filter.val()}`);
}

function createActiveButton($filter) {
    return $('<button />', {
        type: 'button',
        'data-active': true,
        'data-filter': 'active',
        'data-value': $filter.val(),
        class: 'btn btn-outline-primary btn-sm active me-8'
    }).text(`${$filter.data('active')}`);
}

$(document).ready(function () {
    $('[data-filter="location"]').each(function () {
        let $element = $(this);

        let reloadGrid = function (href) {
            // Cancel previous request
            if (window.source !== undefined) {
                // Cancel previous request
                window.source.cancel();
            }

            //Container of items posts
            let $grid = $element.closest('.top-section').find('.bottom-section');

            window.source = window.axios.CancelToken.source();

            window.axios.get(href, {cancelToken: source.token})
                .then(function (response) {
                    //Every child item
                    let $items = $grid.find('.post-element');

                    let $grid_h = $grid.outerHeight();

                    $grid.css('min-height', $grid_h);

                    //Remove old items
                    $items.remove();

                    let $data = $(response.data);

                    // Append pagination
                    let $pagination = $('.shop-filters-container .uq-pagination');
                    let $newPagination = $data.find('.shop-filters-container .uq-pagination').html();

                    $newPagination = $newPagination ? $newPagination : '';

                    $pagination.html($newPagination);

                    let timer = 300;
                    //Add new filtered elements
                    $data.find('.post-element')
                        .each(function () {
                            let $this = $(this);
                            setTimeout(function () {
                                $this.appendTo($grid).hide().fadeIn();
                            }, timer += 50);
                        });

                    setTimeout(function () {
                        $grid.css('min-height', 'auto')
                    }, 500);

                    window.source = undefined;
                }).catch(() => { /*Silence is good*/
            });
        }

        // Prevent close on click in
        let $filter_buttons = $('.uq-filters .dropdown-item .btn-link');

        $filter_buttons.each(function () {
            $(this).on('click', function (e) {
                e.stopPropagation();
            })
        });

        $element.on('filter.applied filter.clean.all', function () {
            let href = $element.attr('action');

            let filters = [];

            $element.find('[data-type="selected-container"] [data-filter],[data-type="selected-container"] [data-search],' +
                '[data-type="selected-container"] [data-active]')
                .each(function () {
                    let $this = $(this);

                    let filter = {
                        name: $this.data('filter') ? $this.data('filter') : 'q',
                        value: $this.data('value'),
                    };

                    filters.push(filter);
                });

            let data = {};

            $(filters).each(function (index, obj) {
                if (data[obj.name] === undefined) {
                    if (['active', 'q'].includes(obj.name)) {
                        data[obj.name] = obj.value;
                    } else {
                        data[obj.name] = [obj.value];
                    }
                } else {
                    data[obj.name].push(obj.value);
                }
            });

            try {
                function encodeQueryData(data) {
                    const ret = [];

                    for (let d in data) {
                        let value = data[d];

                        if (Array.isArray(value)) {
                            for (let i in value) {
                                ret.push(encodeURIComponent(d) + '[]=' + encodeURIComponent(value[i]));
                            }
                        } else {
                            ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
                        }
                    }

                    return ret.join('&');
                }

                let filters = encodeQueryData(data);

                let href_query = href + (filters ? '?' + filters : '');

                window.history.pushState({href: href_query}, '', href_query);

                reloadGrid(document.location);
            } catch (e) {
            }
        });

        /**
         * Apply filter
         *
         * @param e
         */
        let fn = function (e) {
            let $filter = $(e.currentTarget);

            let $form = $filter.closest('[data-filter="location"]');
            let $filterList = $form.closest('[data-filter="location"]').find('[data-type="selected"]');
            let $filterListContainer = $filterList.find('[data-type="selected-container"]');

            let is_active = !!$filter.data('active');

            if (e.type === 'input' || is_active) {
                let search_val = !is_active ? $filter.val() : $filter.is(':checked');

                let filter_data = is_active ? '[data-active]' : '[data-search]';

                // List of applied
                let $filterApplied = $filterListContainer.find(filter_data);

                if (!is_active && $filterApplied.length > 0 && !search_val || is_active && !search_val) {
                    $filterApplied.remove();
                } else if (!$filterApplied.length) {
                    let $filter_clone = is_active ? createActiveButton($filter) : createSearchButton($filter);

                    $filter_clone.on('click', function () {
                        $(this).remove();

                        if (!is_active) {
                            $filter.val('');
                        } else {
                            $filter.prop('checked', false);
                        }

                        $form.trigger('filter.applied');
                    });

                    $filterListContainer.prepend($filter_clone);
                } else if (!is_active) {
                    $filterApplied.data('value', search_val).text(`${$filter.data('search')}: ${search_val}`);
                }
            } else {
                let filter_data = '[data-filter="' + $filter.data('filter') + '"][data-value="' + $filter.data('value') + '"]';

                // List of applied
                let $filterApplied = $filterListContainer.find(filter_data);

                if ($filterApplied.length > 0) {
                    $filterApplied.remove();
                } else {
                    let $filter_clone = $filter.clone();

                    $filter_clone.on('click', fn);
                    $filterListContainer.append($filter_clone);
                }

                //
                if (!$form.find(filter_data).hasClass('active')) {
                    $form.find(filter_data).addClass('active');
                } else {
                    $form.find(filter_data).removeClass('active');
                }
            }

            // Check if container is empty
            if (!$filterListContainer.html().trim()) {
                if (!$filterList.hasClass('d-none')) {
                    $filterList.addClass('d-none')
                }
            } else if ($filterList.hasClass('d-none')) {
                $filterList.removeClass('d-none')
            }

            if (['click', 'input'].includes(e.type)) {
                $form.trigger('filter.applied');
            }
        };

        $element.find('[data-filter]').on('click filter.click', function (e) {
            fn(e);
        });

        $element.find('[data-search]').on('input input.search', function (e) {
            fn(e);
        });

        $element.find('[data-active]').on('click change.click', function (e) {
            fn(e);
        });

        /**
         * Clean all filters applied
         */
        $element.find('[data-type="clear-all"]').on('click', function () {
            let $this = $(this);
            let $form = $this.closest('[data-filter="location"]');

            let $filterList = $form.find('[data-type="selected"]');
            let $filterListContainer = $filterList.find('[data-type="selected-container"]');

            $filterListContainer.find('[data-filter].active,[data-search]').remove();
            $form.find('[data-filter].active').removeClass('active');
            $form.find('[data-search]').val('')

            if (!$filterListContainer.html().trim()) {
                if (!$filterList.hasClass('d-none')) {
                    $filterList.addClass('d-none')
                }
            } else if ($filterList.hasClass('d-none')) {
                $filterList.removeClass('d-none')
            }

            $form.trigger('filter.clean.all');
        });

        /**
         * Apply filters when browser was reloaded
         * or direct access from link
         *
         * @param location
         */
        let loadFilters = function (location) {
            if (location === undefined) {
                location = window.location;
            }

            const params = new URLSearchParams(location.search)

            for (let param of params) {
                let name;

                let index = param[0].indexOf('[');

                if (index !== -1) {
                    name = param[0].slice(0, index);
                } else if (index === -1) {
                    name = param[0];
                }

                let value = param[1];

                if (!['q', 'a'].includes('name')) {
                    $element.find('[data-filter="' + name + '"][data-value="' + value + '"]:not(.active)')
                        .trigger('filter.click');
                } else if (name === 'a') {
                    $element.find('[data-active]').trigger('change.click');
                } else {
                    $element.find('[data-search]').trigger('input.search');
                }
            }
        }

        loadFilters();

        // Prevent submit
        $('body').on('submit', '[data-filter="location"]', function (e) {
            e.preventDefault();
        });

        $(window).on('popstate', function () {
            reloadGrid(document.location);
            loadFilters(document.location);
        });

    });
});
